import { useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { toastContent, toastDuration } from 'config/toast';
import { toaster } from 'components/ui/toaster';
import { ShowToastProps, ToastVariant, UseNovaToast } from 'types/Toast';
import { ErrorStatusType, SuccessStatusType } from 'types/StatusTypes';

type BaseToastContent = {
  title: string;
  description?: string;
};

const variantToToastType = (variant: ToastVariant): 'success' | 'error' | 'warning' => {
  switch (variant) {
    case ToastVariant.SUCCESS:
      return 'success';
    case ToastVariant.ERROR:
      return 'error';
    case ToastVariant.WARNING:
      return 'warning';
    default:
      return 'error';
  }
};

export const useNovaToast = (): UseNovaToast => {
  const getDefaultToast = (variant: ToastVariant): BaseToastContent => {
    switch (variant) {
      case ToastVariant.ERROR:
        return toastContent.error[ErrorStatusType.DEFAULT];
      case ToastVariant.SUCCESS:
        return toastContent.success[SuccessStatusType.DEFAULT];
      default:
        return toastContent.error[ErrorStatusType.DEFAULT];
    }
  };

  const show = useCallback(
    ({ id = uuidv4(), title, description, variant, action }: ShowToastProps) => {
      const { title: defaultTitle, description: defaultDescription } = getDefaultToast(variant);
      // the descriptionText would otherwise be the default description - if you only put in a title
      const descriptionText = title ? description : (description ?? defaultDescription);

      if (toaster.isVisible(id)) {
        return;
      }

      toaster.create({
        id,
        type: variantToToastType(variant),
        title: title ?? defaultTitle,
        description: descriptionText,
        duration: toastDuration,
        action,
        closable: true,
      });
    },
    []
  );

  return { show };
};
